import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IActionPartner,
  IPeriodoUltimos12Meses,
  IPeriodoUltimos12MesesParnter,
} from './interfaces/apiInterfaces';
import { IInitialState, ILastTwelveMonths } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  criptoSent: {
    value: 0,
    quantity: 0,
  },
  criptoReceived: {
    value: 0,
    quantity: 0,
  },
  lastTwelveMonths: [],
};

export const getCriptoFaresFromApi = createAction(
  '@faresApp/criptoFares/GET_CRIPTO_FARES_FROM_API'
);

export const gotCriptoFaresFromApi = createAction<any>(
  '@faresApp/criptoFares/GOT_CRIPTO_FARES_FROM_API'
);

export const gotCriptoFaresPartnerFromApi = createAction<any>(
  '@faresApp/criptoFares/GOT_CRIPTO_FARES_PARTNER_FROM_API'
);

export const gotErrorFromCriptoFaresApi = createAction(
  '@faresApp/criptoFares/GOT_ERROR_FROM_CRIPTO_FARES_API'
);

export const displayCriptoFares = createAction<boolean>(
  '@faresApp/criptoFares/DISPLAY_CRIPTO_FARES'
);

export const logoutCriptoFaresApp = createAction(
  '@faresApp/criptoFares/LOGOUT_CRIPTO_FARES_APP'
);

const criptoFaresReducer = createReducer(INITIAL_STATE, {
  [getCriptoFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
    partner: false,
  }),
  [gotCriptoFaresPartnerFromApi.type]: (state, action: IActionPartner) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: true,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    criptoSent: {
      value: action.payload.cripto_enviada.valor,
      quantity: action.payload.cripto_enviada.quantidade,
    },
    criptoReceived: {
      value: action.payload.cripto_recebida.valor,
      quantity: action.payload.cripto_recebida.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12MesesParnter) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.cripto_enviada.valor,
            quantity: mes.cripto_enviada.quantidade,
          },
          faresReceived: {
            value: mes.cripto_recebida.valor,
            quantity: mes.cripto_recebida.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotCriptoFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    partner: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    criptoSent: {
      value: action.payload.fiducia_clientes_enviadas.valor,
      quantity: action.payload.fiducia_clientes_enviadas.quantidade,
    },
    criptoReceived: {
      value: action.payload.fiducia_wl_recebidos.valor,
      quantity: action.payload.fiducia_wl_recebidos.quantidade,
    },
    lastTwelveMonths: action.payload.periodo.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresPassedOn: {
            value: mes.fiducia_clientes_enviadas.valor,
            quantity: mes.fiducia_clientes_enviadas.quantidade,
          },
          faresReceived: {
            value: mes.fiducia_wl_recebidos.valor,
            quantity: mes.fiducia_wl_recebidos.quantidade,
          },
        };
        return data;
      }
    ),
  }),
  [gotErrorFromCriptoFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
    partner: false,
  }),
  [displayCriptoFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutCriptoFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    partner: false,
    dateSearch: {
      start: '',
      end: '',
    },
  }),
});

export default criptoFaresReducer;
